import { useState, useEffect, useCallback } from 'react';
import salesforceTasksService from 'services/salesforceTasksService';

const useSalesforceTasks = () => {
	const [tasks, setTasks] = useState([]);
	const [completedToday, setCompletedToday] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const fetchTasks = useCallback(async (limit = 50) => {
		setLoading(true);
		setError(null);

		try {
			const data = await salesforceTasksService.getTasks(limit);

			setTasks(data.tasks || []);
			setCompletedToday(data.completed_today || []);
		} catch (err) {
			// 404 means no connection record found
			if (err.message?.includes('404')) {
				setError('not_connected');
			}
			// 403 or 424 means connection exists but is stale/broken
			else if (err.message?.includes('403') || err.message?.includes('424')) {
				setError('reconnect_required');
			} else {
				setError(err.message || 'Failed to fetch Salesforce tasks');
			}
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchTasks();
	}, [fetchTasks]);

	return { tasks, completedToday, loading, error, refetch: fetchTasks };
};

export default useSalesforceTasks;
